import { useLocation } from "react-router-dom";
import WorkspaceList from "./list";
import WorkspaceInfo from "../setting/workspace-manage";
import WorkspaceCreate from "./create";

const Workspace = () => {
  const location = useLocation().pathname;
  const paths = location.split("/");

  switch (paths[2]) {
    case "list":
      return <WorkspaceList />;
    case "create":
      return <WorkspaceCreate />;
  }
};

export default Workspace;
